module.exports = __webpack_public_path__ + "static/media/zxJy.8884723b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zxJy.png
// module id = 1889
// module chunks = 0 1